<template>
  <div>
    <Authenticate/>
    <v-container>
    <v-data-table
    :headers="headers"
    :items="clients"
    :items-per-page="15"
    class="elevation-1">
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Exclusion Database</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <alert :message=message v-if="showMessage">
        </alert>
        <v-alert :value="showError" type="error" dismissible>{{ error }}
        </v-alert>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Add Client</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">Add Client</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="8" md="6">
                    <v-text-field v-model="editedItem.party_id"
                                  label="Client ID"
                                  placeholder="123456"
                                  required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="8" md="6">
                    <v-text-field v-model="editedItem.country"
                                  label="Country"
                                  placeholder="FRANCE"
                                  required>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>

          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
    </template>
  </v-data-table>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import Alert from './Alert.vue';
import Authenticate from './Authenticate.vue';

export default {
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: 'Client ID',
          align: 'start',
          sortable: false,
          value: 'party_id',
        },
        { text: 'Creation date', value: 'current_date' },
        { text: 'Country', value: 'country' },
        { text: 'Author', value: 'author' },
        { text: 'Actions', value: 'actions' },
      ],
      clients: [],
      editedItem: {
        party_id: '',
        country: '',
        author: this.$store.getters.userMail,
      },
      defaultItem: {
        party_id: '',
        country: '',
        author: this.$store.getters.userMail,
      },
      message: '',
      showMessage: false,
      error: '',
      showError: false,
    };
  },
  components: {
    Authenticate,
    alert: Alert,
  },
  watch: {
    dialog(val) {
      // eslint-disable-next-line
      val || this.close();
    },
  },
  methods: {

    getClients() {
      const path = '/api/exclusion';
      axios.get(path)
        .then((res) => {
          this.clients = res.data.clients;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
          if (error.response.status === 403) {
            this.$root.$emit('signout');
          }
        });
    },
    deleteItem(item) {
      // eslint-disable-next-line
      confirm('Are you sure you want to delete this item?') && this.removeClient(item.party_id);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        // eslint-disable-next-line
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      this.showError = false;
      this.showMessage = false;
      this.addClient(this.editedItem);
      this.close();
    },
    addClient(payload) {
      const path = '/api/exclusion';
      axios.post(path, payload)
        .then((response) => {
          this.getClients();
          this.message = response.data.message;
          this.showMessage = true;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          this.error = error.response.data.error;
          this.showError = true;
          this.getClients();
        });
    },
    removeClient(partyId) {
      const path = `/api/exclusion/${partyId}`;
      axios.delete(path)
        .then(() => {
          this.getClients();
          this.message = 'Client removed!';
          this.showMessage = true;
        })
        .catch((error) => {
          // eslint-disable-next-line
      console.error(error);
          this.getClients();
        });
    },
  },
  created() {
    this.getClients();
  },
};
</script>
